module.exports = __webpack_public_path__ + "static/media/SF-16-A.9387b3b6.mp3";